import React, {useState} from 'react';
import './finalApproval.scss'

const SeparatedFinalApproval = () => {
  return <div>
      FINAL APPROVAL SCREEN
  </div>;
};

export default SeparatedFinalApproval;
